import React from "react";
import NutrientRow from "./NutrientRow";
import "./NutrientInfo.css";
const langData = require("../../../Data/language.json");

const NutrientInfo = ({ language, data }) => {
  let evenRow = true;
  if (data !== undefined && data !== "") {
    return (
      <div id="nutrientTable">
        <NutrientRow
          name={langData[language].nutrients.name}
          amount={langData[language].nutrients.amount}
          header={true}
        />
        {data.map((nutrient, index) => {
          evenRow = !evenRow;
          return (
            <NutrientRow
              key={`nutrient-${index}`}
              language={language}
              nutrient_id={nutrient.nutrient_id}
              amount={nutrient.amount}
              unit={nutrient.unit_id}
              header={false}
              evenRow={evenRow}
            />
          );
        })}
      </div>
    );
  } else {
    return <div>{langData[language].nutrients.noData}</div>;
  }
};

export default NutrientInfo;
